// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + ".min." + {"349":"e11664e9e53176644e11","688":"9359b9310f17f3612e91"}[chunkId] + ".js";
};